// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"class-manager","130":"qunfa","467":"download","634":"empty","792":"main","962":"home","966":"login"}[chunkId] + "." + {"23":"e2d548b4","130":"a6027395","467":"cbc2b10d","634":"7718ca78","792":"3fcc5c27","962":"d1c9bcfc","966":"49b7d3f0"}[chunkId] + ".css";
};